import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
 selector: 'iho-accommodation',
 templateUrl: './accommodation.component.html',
 styleUrls: ['./accommodation.component.scss'],
})
export class AccommodationComponent implements OnInit {
 router = inject(Router);
 route = inject(ActivatedRoute);
 accommodationState = '';

 ngOnInit(): void {
  this.accommodationState = this.route.snapshot.data['accommodation'];
 }
}
